module.exports = __webpack_public_path__ + "img/TechMarketExchance1_ua.9b9f4361.webp";